import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/gtw-elements/src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ExProjectReviewService {

    private readonly GET_PROJECTS_BY_YEAR_URL = "/projectReview/getProjectsByTaxyear";
    private readonly GET_PROJECTS_STEPS = "/projectReview/getProjectSteps";
    private readonly GET_TRANSACTION_DATA = "/projectReview/getTransactionData";

    tableIndexCache = 0;
    menuOpenCache = true;
    projectListCache = [];
    transStepDataCache = [];
    transDataCache = [];
    selectedProjectCache: {} | undefined = {};

    constructor(private http: HttpClient){

    }

    resetCache() {
        this.tableIndexCache = 0;
        this.menuOpenCache = true;
        this.projectListCache = [];
        this.transStepDataCache = [];
        this.transDataCache = [];
        this.selectedProjectCache = undefined;
    };

    getProjectsByTaxYear(taxYear: string){
        return this.http.get<any>(environment.custom_api_url +  this.GET_PROJECTS_BY_YEAR_URL + `?taxYear=${taxYear}`);
    }
    getProjectSteps(projectId: string, filterParams: any){
        return this.http.get<any>(environment.custom_api_url +  this.GET_PROJECTS_STEPS + `?project_id=${projectId}&tax_year=${filterParams.tax_year}&scenario=${filterParams.scenario}&filingKey=${filterParams.filing_key}&parent_me_string=${filterParams.parent_me_string}`);
    }
    getTransactionData(projectId: string, filterParams: any){
        return this.http.get<any>(environment.custom_api_url +  this.GET_TRANSACTION_DATA + `?project_id=${projectId}&tax_year=${filterParams.tax_year}&scenario=${filterParams.scenario}&filingKey=${filterParams.filing_key}&parent_me_string=${filterParams.parent_me_string}`);
    }
}
